export default angular
    .module("app.widgets", []);
